module.exports = "<div class=\"navbar-form navbar-left shift\">\n    <form [formGroup]=\"submitForm\" (ngSubmit)=\"onSubmit()\">\n\n        <input formControlName=\"name\" style=\"width: 400px\"\n               class=\"form-control form-control-lg\" placeholder=\"Search By Name, Email, Mobile Number or Employee Id\"/>\n        <button class=\"btn btn-default-basic\"><i class=\"fa fa-search\"></i>\n        </button>\n\n    </form>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/search-form/search-form.component.html
// module id = ../../../../../src/app/search-form/search-form.component.html
// module chunks = 0